(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-offers-menu-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-offers-navigation')) {
    class CpOffersNavigation extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onCategoryClick);
        this.addEventListener('toggle', this.onToggle, true);
        document.addEventListener('keydown', this.onKeydown, true);
        document.addEventListener('pointerdown', this.onOutsidePointer, true);
        document.addEventListener('focusin', this.onOutsideFocus);
        window.addEventListener('resize', this.positionPanel);
        window.addEventListener('scroll', this.positionPanel, true);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onCategoryClick);
        this.removeEventListener('toggle', this.onToggle, true);
        document.removeEventListener('keydown', this.onKeydown, true);
        document.removeEventListener('pointerdown', this.onOutsidePointer, true);
        document.removeEventListener('focusin', this.onOutsideFocus);
        window.removeEventListener('resize', this.positionPanel);
        window.removeEventListener('scroll', this.positionPanel, true);
        this.close();
      }

      get details() {
        return this.querySelector('details');
      }

      get panel() {
        return this.querySelector('[data-offers-panel]');
      }

      close(restoreFocus = false) {
        const details = this.details;
        if (!details) return;
        const panel = this.panel;
        if (panel?.hidePopover && panel.matches(':popover-open')) panel.hidePopover();
        details.open = false;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) details.querySelector('summary')?.focus();
      }

      onToggle = (event) => {
        const details = this.details;
        if (event.target !== details) return;
        details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
        if (!details.open) {
          this.close();
          return;
        }
        const panel = this.panel;
        if (panel?.showPopover && !panel.matches(':popover-open')) panel.showPopover();
        this.positionPanel();
      };

      positionPanel = () => {
        if (!this.details?.open || !this.panel) return;
        const rect = this.getBoundingClientRect();
        const width = Math.min(360, window.innerWidth - 24);
        const left = Math.max(12, Math.min(rect.left, window.innerWidth - width - 12));
        const top = Math.max(12, rect.bottom + 8);
        this.panel.style.setProperty('--cp-offers-panel-left', `${left}px`);
        this.panel.style.setProperty('--cp-offers-panel-top', `${top}px`);
        this.panel.style.setProperty('--cp-offers-panel-height', `${Math.max(100, window.innerHeight - top - 12)}px`);
      };

      onOutsidePointer = (event) => {
        if (this.details?.open && !event.composedPath().includes(this)) this.close();
      };

      onOutsideFocus = (event) => {
        if (this.details?.open && !event.composedPath().includes(this)) this.close();
      };

      onCategoryClick = (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.cp-offers-menu__category')) {
          this.close(event.detail === 0);
        }
      };

      onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        if (!this.details?.open) return;
        this.close(true);
        event.preventDefault();
        event.stopPropagation();
      };
    }

    customElements.define('cp-offers-navigation', CpOffersNavigation);
  }
  } catch(e) { console.error(e); }
})();

})();
